const modalBackdrop = "_modalBackdrop_hdghf_3";
const modalFooter = "_modalFooter_hdghf_10";
const modalHeader = "_modalHeader_hdghf_15";
const modalEntering = "_modalEntering_hdghf_23";
const modalExiting = "_modalExiting_hdghf_27";
const styles = {
  modalBackdrop,
  modalFooter,
  modalHeader,
  modalEntering,
  modalExiting
};
export {
  styles as s
};
